// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22DFH","controls":"styles_controls__qHE8t","charLimit":"styles_charLimit__MG0WV","input":"styles_input__3Q-2Q","send":"styles_send__1FBhl"};